import { useHistory } from 'react-router-dom';
import styles from './PopularQuestion.module.scss';

type PopularQuestionProps = {
  category: string;
  subCategory: string;
  question: string;
};

const PopularQuestion: React.FC<PopularQuestionProps> = ({ category, subCategory, question }) => {
  const history = useHistory();
  const path = category.split(' ').join('-').toLowerCase();
  return (
    <div
      className={styles.popularQuestionContainer}
      onClick={() => history.push(`/category/${path}`, { category, subCategory, selectedQuestion: question })}
    >
      <p>{question}</p>
    </div>
  );
};

export default PopularQuestion;
